import { useState } from "react";
import { CaretUp, CaretDown, ArrowsDownUp } from "@phosphor-icons/react";

// Lightweight client-side sorting for in-memory tables.
export function useSort(initialBy = "", initialDir = "asc") {
  const [sort, setSort] = useState({ by: initialBy, dir: initialDir });
  const toggle = (field) =>
    setSort((p) => (p.by === field ? { by: field, dir: p.dir === "asc" ? "desc" : "asc" } : { by: field, dir: "asc" }));

  const sortRows = (rows, accessors = {}) => {
    if (!sort.by || !Array.isArray(rows)) return rows;
    const acc = accessors[sort.by] || ((r) => r[sort.by]);
    const dir = sort.dir === "asc" ? 1 : -1;
    return [...rows].sort((a, b) => {
      let va = acc(a), vb = acc(b);
      va = va == null ? "" : va;
      vb = vb == null ? "" : vb;
      if (typeof va === "number" && typeof vb === "number") return (va - vb) * dir;
      return String(va).localeCompare(String(vb), undefined, { numeric: true, sensitivity: "base" }) * dir;
    });
  };

  return { sort, toggle, sortRows };
}

export function SortTh({ label, field, sort, onSort, align = "left", className = "" }) {
  const active = sort.by === field;
  return (
    <th className={`px-4 py-2.5 text-${align} ${className}`}>
      <button
        type="button"
        data-testid={`sort-${field}`}
        onClick={() => onSort(field)}
        className={`inline-flex items-center gap-1 uppercase tracking-wider transition-colors hover:text-[#0055FF] ${active ? "text-[#0055FF]" : "text-neutral-500"}`}
      >
        {label}
        {active ? (
          sort.dir === "asc" ? <CaretUp size={12} weight="bold" /> : <CaretDown size={12} weight="bold" />
        ) : (
          <ArrowsDownUp size={12} className="text-neutral-300" />
        )}
      </button>
    </th>
  );
}
